onReady(($) => {
    const filterForm = document.querySelector('#filter-form')

    if (!filterForm) {
        return
    }

    const langPrefix = filterForm.dataset.lang === 'en' ? '' : `/${filterForm.dataset.lang}`
    const filters_overlay = $(".filters-overlay")
    const filters_bar = $(".filter-bar")
    const nav_container = $(".navigationcontainer")
    const $window = $(window);

    $("#filters")
        .click(function () {
            filters_overlay.addClass("visible")
            $(this)
                .addClass('active')
        })

    $(".close")
        .click(function () {
            filters_overlay.removeClass("visible")
            $("#filters")
                .removeClass('active')
        })

    $(".filters-overlay #clear_all")
        .on('click', function () {
            $(".filters-overlay input[type=checkbox]")
                .prop("checked", false)
        })

    filterForm.addEventListener('submit', (event) => {
        const selectedFilters = filterForm.querySelectorAll('input[type=checkbox]:checked')

        // If no filters selected redirect to insights
        if (selectedFilters.length === 0) {
            event.preventDefault()
            window.location.href = `${langPrefix}/insights/`
            return
        }

        // If only 1 content type filter is selected, go to dedicated entry page
        const selectedContentTypes = filterForm.querySelectorAll('input[type=checkbox].content-type-filter:checked')
        if (selectedFilters.length === 1 && selectedContentTypes.length === 1) {
            event.preventDefault()
            const selectedContentTypeFilter = Array.from(selectedContentTypes)[0]
            window.location.href = `${langPrefix}/${selectedContentTypeFilter.dataset.slug}/`
        }
    })
    $window.on('scroll', () => {
        if ($window.scrollTop()) {
            filters_bar.addClass('slide-up')
            nav_container.addClass('slide-up')
            return
        }

        filters_bar.removeClass('slide-up')
        nav_container.removeClass('slide-up')
    });

})
